module.exports = __webpack_public_path__ + "static/media/delete-icon.3f45cc09.svg";